import type { RadioChangeEvent } from 'antd';
import { Form, Radio } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { AVAILABILITY_MODE } from 'app/typings/core/admin/experiences/enum/availabilityMode';
import { OPENING_CONFIGURATION_TYPE } from 'app/typings/core/admin/experiences/enum/openingConfiguration';

import { markFormDirty } from '../../../hook/useValidationStore';

import { StockConfigurationTable } from './StockConfigurationTable';

const REQUIRED_RULE = [{ required: true, message: 'Required' }];

export const TimeslotStockFields = () => {
  const { isViewMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();

  const availabilityMode = Form.useWatch<AVAILABILITY_MODE>(
    'availabilityMode',
    form
  );
  const isTimeslotDaytimeOnly = Form.useWatch<boolean>(
    'isTimeslotDaytimeOnly',
    form
  );

  const isTimeslot = availabilityMode === AVAILABILITY_MODE.TIMESLOT;

  const handleDaytimeOnlyChange = (e: RadioChangeEvent) => {
    markFormDirty();

    if (e.target.value === true) {
      form.setFieldValue(
        ['openingConfiguration', 'stockConfiguration', 'type'],
        OPENING_CONFIGURATION_TYPE.DAILY
      );
    } else {
      form.setFieldValue(['openingConfiguration', 'stockConfiguration'], {
        type: OPENING_CONFIGURATION_TYPE.CONSTANT,
        configuration: { stock: null },
      });
    }
  };

  if (!isTimeslot) {
    return null;
  }

  return (
    <>
      <FormLineLayout
        label="Apply timeslots on"
        labelOnTop
        disabled={isViewMode}
        isRequired
        description={`Timeslots are ${
          isTimeslotDaytimeOnly ? 'hidden' : 'mandatory'
        } for night users`}
      >
        <Form.Item
          name="isTimeslotDaytimeOnly"
          rules={REQUIRED_RULE}
          initialValue={true}
        >
          <Radio.Group disabled={isViewMode} onChange={handleDaytimeOnlyChange}>
            <Radio value={true}>Daytime only</Radio>
            <Radio value={false}>Daytime & Night stay</Radio>
          </Radio.Group>
        </Form.Item>
      </FormLineLayout>

      {isTimeslotDaytimeOnly === true && (
        <FormLineLayout label="Night stock" labelOnTop disabled={isViewMode}>
          <StockConfigurationTable forceAlwaysIncludedWithNight />
        </FormLineLayout>
      )}
    </>
  );
};
